module.exports = __webpack_public_path__ + "static/media/photo24.8f27dbc2.jpg";